import script from "./DropsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./DropsHome.vue?vue&type=script&setup=true&lang=js"

import "./DropsHome.vue?vue&type=style&index=0&id=5dde26b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dde26b8"]])

export default __exports__